export const DISTRIBUTION_PERIOD_SHOW_TABS = [
  'general',
  'elibri_events',
] as const;

export type DistributionPeriodShowTab =
  (typeof DISTRIBUTION_PERIOD_SHOW_TABS)[number];

export const DISTRIBUTION_PERIOD_DEFAULT_TAB: DistributionPeriodShowTab =
  'general';
